import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MonogramCreateJsonDataContainerMutationVariables = Types.Exact<{
  payload: Types.CreateJsonDataContainerPayload;
}>;

export type MonogramCreateJsonDataContainerMutation = {
  __typename?: 'Mutation';
  createJsonDataContainer: { __typename?: 'JsonDataContainer'; id: string; eventId: string; content: any; type: string; schemaUrl: string };
};

export type MonogramJsonDataContainerByIdQueryVariables = Types.Exact<{
  payload: Types.JsonDataContainerByIdPayload;
}>;

export type MonogramJsonDataContainerByIdQuery = {
  __typename?: 'Query';
  jsonDataContainerById?: { __typename?: 'JsonDataContainer'; id: string; eventId: string; content: any; type: string; schemaUrl: string } | null;
};

export const MonogramCreateJsonDataContainerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MonogramCreateJsonDataContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateJsonDataContainerPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJsonDataContainer' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type MonogramCreateJsonDataContainerMutationFn = Apollo.MutationFunction<MonogramCreateJsonDataContainerMutation, MonogramCreateJsonDataContainerMutationVariables>;

/**
 * __useMonogramCreateJsonDataContainerMutation__
 *
 * To run a mutation, you first call `useMonogramCreateJsonDataContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMonogramCreateJsonDataContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [monogramCreateJsonDataContainerMutation, { data, loading, error }] = useMonogramCreateJsonDataContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useMonogramCreateJsonDataContainerMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<MonogramCreateJsonDataContainerMutation, MonogramCreateJsonDataContainerMutationVariables>,
) {
  return ApolloReactHooks.useMutation<MonogramCreateJsonDataContainerMutation, MonogramCreateJsonDataContainerMutationVariables>(
    MonogramCreateJsonDataContainerDocument,
    baseOptions,
  );
}
export type MonogramCreateJsonDataContainerMutationHookResult = ReturnType<typeof useMonogramCreateJsonDataContainerMutation>;
export type MonogramCreateJsonDataContainerMutationResult = Apollo.MutationResult<MonogramCreateJsonDataContainerMutation>;
export type MonogramCreateJsonDataContainerMutationOptions = Apollo.BaseMutationOptions<MonogramCreateJsonDataContainerMutation, MonogramCreateJsonDataContainerMutationVariables>;
export const MonogramJsonDataContainerByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MonogramJsonDataContainerById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JsonDataContainerByIdPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jsonDataContainerById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMonogramJsonDataContainerByIdQuery__
 *
 * To run a query within a React component, call `useMonogramJsonDataContainerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonogramJsonDataContainerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonogramJsonDataContainerByIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useMonogramJsonDataContainerByIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<MonogramJsonDataContainerByIdQuery, MonogramJsonDataContainerByIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<MonogramJsonDataContainerByIdQuery, MonogramJsonDataContainerByIdQueryVariables>(MonogramJsonDataContainerByIdDocument, baseOptions);
}
export function useMonogramJsonDataContainerByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MonogramJsonDataContainerByIdQuery, MonogramJsonDataContainerByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<MonogramJsonDataContainerByIdQuery, MonogramJsonDataContainerByIdQueryVariables>(MonogramJsonDataContainerByIdDocument, baseOptions);
}
export type MonogramJsonDataContainerByIdQueryHookResult = ReturnType<typeof useMonogramJsonDataContainerByIdQuery>;
export type MonogramJsonDataContainerByIdLazyQueryHookResult = ReturnType<typeof useMonogramJsonDataContainerByIdLazyQuery>;
export type MonogramJsonDataContainerByIdQueryResult = Apollo.QueryResult<MonogramJsonDataContainerByIdQuery, MonogramJsonDataContainerByIdQueryVariables>;
